e360.factory('experiencesNotices', [
   'experiencesConstants',
   'experiencesService',
   'session',

   function(experiencesConstants, experiencesService, session) {
      var factory = function (experiences) {
         var self = this,
            activeType = false,
            types = [],
            emails = [],
            notices = [],
            rsvpFriends = false,
            rsvpGuests = false,
            rsvpSite = false;

         _.each(experiences, function(e) {
            if (!_.contains(types, e.type)) {
               types.push(e.type);
            }

            if (e.typeDefinition && e.typeDefinition.slug &&
               !_.contains(emails, e.typeDefinition.slug)) {

               emails.push(e.typeDefinition.slug);
            }

            if (e.type == experiencesConstants.TYPE_RSVP_SITE) {
               rsvpSite = e;
               rsvpFriends = e.settings.friendsPerAttendee > 0;
               rsvpGuests = e.settings.guestsPerAttendee > 0;

               if (!rsvpGuests) {
                  rsvpGuests = _.any(e.settings.guestTypeGuestsPerAttendee, function (g) {
                     return g > 0;
                  });
               }
            }
         });

         var rsvp = experiencesConstants.EXPERIENCES.rsvp_emails;

         this.hasConfirmationEmail = _.contains(emails, rsvp[0].slug);
         this.hasInviteEmail = _.contains(emails, rsvp[1].slug);
         this.hasInviteFriendEmail = _.contains(emails, rsvp[2].slug);
         this.hasInviteGuestEmail = _.contains(emails, rsvp[3].slug);
         this.hasReminderEmail = _.contains(emails, rsvp[4].slug);
         this.hasMediaSMS = _.contains(types, experiencesConstants.TYPE_SMS);
         this.hasMediaEmail = _.contains(emails, experiencesConstants.EXPERIENCES.app_page[1]);
         this.hasRsvpSite = _.contains(types, experiencesConstants.TYPE_RSVP_SITE);
         this.hasMediaPage = _.contains(types, experiencesConstants.TYPE_MEDIA_PAGE);
         this.hasApp = _.contains(types, experiencesConstants.TYPE_APP);
         this.hasQrPage = _.contains(types, experiencesConstants.TYPE_QRCODE);
         this.hasRsvpGuests = rsvpGuests;
         this.hasRsvpFriends = rsvpFriends;

         var rsvpErrorCheck = function() {
            if (self.hasRsvpSite && activeType.slug === 'confirmation-email' && emails.indexOf('confirmation-email') === -1) {
               return {
                  message: 'This experience is required for your RSVP Site'
               };
            }

            if (self.hasRsvpSite && self.hasRsvpFriends && activeType.slug === 'friend-invite-email' && emails.indexOf('friend-invite-email') === -1) {
               return {
                  message: 'This experience is required for your RSVP Site'
               };
            }

            if (self.hasRsvpSite && self.hasRsvpGuests && activeType.slug === 'guest-invite-email' && emails.indexOf('guest-invite-email') === -1) {
               return {
                  message: 'This experience is required for your RSVP Site'
               };
            }

            if (
               self.hasRsvpSite &&
               activeType.id === experiencesConstants.TYPE_RSVP_SITE &&
               emails.indexOf('confirmation-email') === -1
            ) {
               return {
                  message: 'Your RSVP Site setup is incomplete, please create the required experiences below.'
               };
            } else if (
               self.hasRsvpSite &&
               self.hasRsvpFriends &&
               activeType.id === experiencesConstants.TYPE_RSVP_SITE &&
               emails.indexOf('friend-invite-email') === -1
            ) {
               return {
                  message: 'Your RSVP Site setup is incomplete, please create the required experiences below.'
               };
            } else if (
               self.hasRsvpSite &&
               self.hasRsvpGuests &&
               activeType.id === experiencesConstants.TYPE_RSVP_SITE &&
               emails.indexOf('guest-invite-email') === -1
            ) {
               return {
                  message: 'Your RSVP Site setup is incomplete, please create the required experiences below.'
               };
            }

            return false;
         };

         var rsvpWarningCheck = function () {
           if (self.hasRsvpSite && !self.hasQrPage && activeType.id === experiencesConstants.TYPE_QRCODE) {
              return {
                 message: 'This experience is required if checking people into a physical event by scanning a QR code.'
              };
           }

           return false;
         };

         function appErrorCheck() {
            if (activeType.slug === 'media-email' && emails.indexOf('media-email') === -1 && appHasMediaSendTo('email')) {
               return {
                  message: 'This experience is required for your app'
               };
            } else if (experiencesService.isSMS(activeType.id) && !self.hasMediaSMS && appHasMediaSendTo('sms')) {
               return {
                  message: 'This experience is required for your app'
               };
            } else if (experiencesService.isMedia(activeType.id) && !self.hasMediaPage && appHasMediaModule()) {
               return {
                  message: 'This experience is required for your app'
               };
            }
         }

         function appHasMediaModule() {
            var result = false;
            _.each(experiences, function(e) {
               if (e.type == experiencesConstants.TYPE_APP && e.settings.steps) {
                  _.each(e.settings.steps, function(s) {
                     if (s.type == 4 || s.type == 5) {
                        result = true;
                        return false;
                     }
                  });

                  return !result;
               }
            });
            return result;
         }

         function appHasMediaSendTo(sendTo) {
            return _.any(experiences, function(e) {
               if (e.type == experiencesConstants.TYPE_APP && e.settings.steps) {
                  return _.any(e.settings.steps, function(s) {
                     if (s.type == 4 && s.photoSettings.sendTo.indexOf(sendTo) !== -1) {
                        return true;
                     } else if (s.type == 5 && s.videoSettings.sendTo.indexOf(sendTo) !== -1) {
                        return true;
                     }

                     return false;
                  });
               }

               return false;
            });
         }

         this.getErrorsForType = function(type) {
            if (!type) {
               return false;
            }

            activeType = type;

            var rsvpErrors = rsvpErrorCheck();
            if (rsvpErrors) {
               return rsvpErrors;
            }

            var appErrors = appErrorCheck();
            if (appErrors) {
               return appErrors;
            }

            return false;
         };

         this.getWarningsForType = function(type) {
           if (!type) {
              return false;
           }

           activeType = type;

           var rsvpWarnings = rsvpWarningCheck();
           if (rsvpWarnings) {
             return rsvpWarnings;
           }

           return false;
         };

         this.getToolTipsForType = function(type) {
            if (!type) {
               return false;
            }

            activeType = type;

            if (activeType.slug === 'reminder-email' && emails.indexOf('reminder-email') !== -1) {
               return {
                  message: 'Reminder emails are sent 2 days before the event'
               };
            } else if (activeType.slug === 'reminder-email' && emails.indexOf('reminder-email') == -1) {
               return {
                  message: 'This experience will send a reminder email to pre-registrants prior to the event, and is recommended for your RSVP site.'
               };
            }

            if (activeType.slug === 'webinar-email' && emails.indexOf('webinar-email') !== -1) {
               return {
                  message: 'Join Link emails are sent 1 hour before the event'
               };
            } else if (activeType.slug === 'webinar-email' && emails.indexOf('webinar-email') == -1) {
               return {
                  message: 'This experience will send an email with a virtual event join link to pre-registrants prior to the event.'
               };
            }

            if (activeType.slug === 'thank-you-email' && emails.indexOf('thank-you-email') !== -1) {
               return {
                  message: 'Thank You emails are sent 1 day after the event'
               };
            }

            if (activeType.slug === 'sorry-email' && emails.indexOf('sorry-email') !== -1) {
               return {
                  message: 'Sorry emails are sent 2 days after the event'
               };
            }

            return false;
         };

         this.getRestrictionsForType = function(type) {
            if (!type) {
               return false;
            }

            activeType = type;

            var profile = {
               isRsvpEmail: _.find(experiencesConstants.EXPERIENCES.rsvp_emails, function(e) {
                  return e.slug == activeType.slug;
               }),
               isAppExperience: _.find(experiencesConstants.EXPERIENCES.app_page, function(e) {
                  return e.slug == activeType.slug;
               })
            };

            if (profile.isRsvpEmail && !self.hasRsvpSite) {
               return {
                  message: 'Please create an RSVP Site experience first'
               };
            } else if (experiencesService.isQRCode(activeType.id) && !self.hasRsvpSite) {
               return {
                  message: 'Please create an RSVP Site experience first'
               };
            } else if (activeType.email_name == 'RsvpTellFriend' && !self.hasRsvpFriends) {
               return {
                  message: 'Your RSVP Site is configured with 0 friends per preregistrant.'
               };
            } else if (activeType.email_name == 'RsvpGuestInvite' && !self.hasRsvpGuests) {
               return {
                  message: 'Your RSVP Site is configured with 0 secondary guests per preregistrant.'
               };
            } else if (experiencesService.isPassbook(activeType.id) && !self.hasConfirmationEmail){
               return {
                  message: 'Please create a confirmation email first'
               };
            }

            return false;
         };
      };

      return factory;
   }
]);
